"use strict"; // Copyright 2013 Google LLC
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var _regeneratorRuntime = require("/Users/cachi/pincelit-now/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/cachi/pincelit-now/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/cachi/pincelit-now/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/cachi/pincelit-now/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/cachi/pincelit-now/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/cachi/pincelit-now/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/cachi/pincelit-now/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var arrify = require("arrify");

var gcpMetadata = require("gcp-metadata");

var messages = require("../messages");

var oauth2client_1 = require("./oauth2client");

var Compute =
/*#__PURE__*/
function (_oauth2client_1$OAuth) {
  _inherits(Compute, _oauth2client_1$OAuth);

  /**
   * Google Compute Engine service account credentials.
   *
   * Retrieve access token from the metadata server.
   * See: https://developers.google.com/compute/docs/authentication
   */
  function Compute() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Compute);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Compute).call(this, options)); // Start with an expired refresh token, which will automatically be
    // refreshed before the first API call is made.

    _this.credentials = {
      expiry_date: 1,
      refresh_token: 'compute-placeholder'
    };
    _this.serviceAccountEmail = options.serviceAccountEmail || 'default';
    _this.scopes = arrify(options.scopes);
    return _this;
  }
  /**
   * Indicates whether the credential requires scopes to be created by calling
   * createdScoped before use.
   * @deprecated
   * @return Boolean indicating if scope is required.
   */


  _createClass(Compute, [{
    key: "createScopedRequired",
    value: function createScopedRequired() {
      // On compute engine, scopes are specified at the compute instance's
      // creation time, and cannot be changed. For this reason, always return
      // false.
      messages.warn(messages.COMPUTE_CREATE_SCOPED_DEPRECATED);
      return false;
    }
    /**
     * Refreshes the access token.
     * @param refreshToken Unused parameter
     */

  }, {
    key: "refreshTokenNoCache",
    value: function () {
      var _refreshTokenNoCache = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(refreshToken) {
        var tokenPath, data, instanceOptions, tokens;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                tokenPath = "service-accounts/".concat(this.serviceAccountEmail, "/token");
                _context.prev = 1;
                instanceOptions = {
                  property: tokenPath
                };

                if (this.scopes.length > 0) {
                  instanceOptions.params = {
                    scopes: this.scopes.join(',')
                  };
                }

                _context.next = 6;
                return gcpMetadata.instance(instanceOptions);

              case 6:
                data = _context.sent;
                _context.next = 14;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](1);
                _context.t0.message = "Could not refresh access token: ".concat(_context.t0.message);
                this.wrapError(_context.t0);
                throw _context.t0;

              case 14:
                tokens = data;

                if (data && data.expires_in) {
                  tokens.expiry_date = new Date().getTime() + data.expires_in * 1000;
                  delete tokens.expires_in;
                }

                this.emit('tokens', tokens);
                return _context.abrupt("return", {
                  tokens: tokens,
                  res: null
                });

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 9]]);
      }));

      function refreshTokenNoCache(_x) {
        return _refreshTokenNoCache.apply(this, arguments);
      }

      return refreshTokenNoCache;
    }()
    /**
     * Fetches an ID token.
     * @param targetAudience the audience for the fetched ID token.
     */

  }, {
    key: "fetchIdToken",
    value: function () {
      var _fetchIdToken = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(targetAudience) {
        var idTokenPath, idToken, instanceOptions;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                idTokenPath = "service-accounts/".concat(this.serviceAccountEmail, "/identity") + "?format=full&audience=".concat(targetAudience);
                _context2.prev = 1;
                instanceOptions = {
                  property: idTokenPath
                };
                _context2.next = 5;
                return gcpMetadata.instance(instanceOptions);

              case 5:
                idToken = _context2.sent;
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);
                _context2.t0.message = "Could not fetch ID token: ".concat(_context2.t0.message);
                throw _context2.t0;

              case 12:
                return _context2.abrupt("return", idToken);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 8]]);
      }));

      function fetchIdToken(_x2) {
        return _fetchIdToken.apply(this, arguments);
      }

      return fetchIdToken;
    }()
  }, {
    key: "wrapError",
    value: function wrapError(e) {
      var res = e.response;

      if (res && res.status) {
        e.code = res.status.toString();

        if (res.status === 403) {
          e.message = 'A Forbidden error was returned while attempting to retrieve an access ' + 'token for the Compute Engine built-in service account. This may be because the Compute ' + 'Engine instance does not have the correct permission scopes specified: ' + e.message;
        } else if (res.status === 404) {
          e.message = 'A Not Found error was returned while attempting to retrieve an access' + 'token for the Compute Engine built-in service account. This may be because the Compute ' + 'Engine instance does not have any permission scopes specified: ' + e.message;
        }
      }
    }
  }]);

  return Compute;
}(oauth2client_1.OAuth2Client);

exports.Compute = Compute;